import { Component, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'app-time-display',
    templateUrl: './time-display.component.html',
    styleUrls: ['./time-display.component.scss']
})
export class TimeDisplayComponent implements OnInit, OnDestroy {
    private sub: Subscription;

    timeString: string;
    timeType = 'LOCAL';
    dots = ':';
    dotsVisible = true;

    updateTime() {
        const timeObj = moment().utc();
        this.timeString = timeObj.format();
        this.dotsVisible = timeObj.seconds() % 2 === 0;
    }

    ngOnInit() {
        this.updateTime();
        this.sub = interval(1000).subscribe(() => this.updateTime());
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
